import { Flex, Spacing } from '@billy/design-system'

import { ExpandedRowsContextProvider } from '../../../contexts/expandedRowsContext'
import { BalanceSheetActions } from './components/BalanceSheetActions'
import { BalanceSheetTable } from './components/BalanceSheetTable'
import { useBalanceSheetData } from './hooks/useBalanceSheetData'

export const BalanceSheetReport = () => {
  const { allExpandableIds } = useBalanceSheetData()

  return (
    <ExpandedRowsContextProvider allExpandableIds={allExpandableIds}>
      <Flex gap={Spacing.S16} flexDirection="column">
        <BalanceSheetActions />
        <BalanceSheetTable />
      </Flex>
    </ExpandedRowsContextProvider>
  )
}
